import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "inline-block",
    "width": "100%"
  }
};
import { ref, onBeforeMount } from 'vue';

import { reactive, computed, watch } from 'vue';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-industry-select',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const industries = ref([]);
    const formData = reactive({
      isLoaded: false,
      modelValue: ''
    });
    const modelValue = computed(() => {
      if (!formData.isLoaded) {
        return '';
      }
      return formData.modelValue;
    });
    const {
      runAsync: getIndustryTree
    } = fetchApi('industry.getTree');
    const loadIndustries = async () => {
      const {
        error,
        rows
      } = await getIndustryTree({
        maxLevel: 3,
        search: ''
      });
      if (error) return;
      industries.value = [...rows];
      formData.isLoaded = true;
    };
    const handleUpdateModelValue = val => {
      if (val !== formData.modelValue) {
        formData.modelValue = val;
        emit('update:modelValue', val);
      }
    };
    onBeforeMount(() => {
      loadIndustries(formData.modelValue);
    });
    watch(() => props.modelValue, async val => {
      formData.modelValue = val;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_vxe_tree_select = _resolveComponent("vxe-tree-select");
      return _openBlock(), _createElementBlock("span", _hoisted_1, [_createVNode(_component_vxe_tree_select, _mergeProps(_ctx.$attrs, {
        options: industries.value,
        "model-value": _unref(modelValue),
        "option-props": {
          value: 'id',
          label: 'name',
          children: 'children'
        },
        "onUpdate:modelValue": handleUpdateModelValue
      }), null, 16, ["options", "model-value"])]);
    };
  }
};